import { z } from "zod/v4";

export const SyncOfferMetafieldsResponseBodySchema = z.object({
  status: z.string(),
});

export type SyncOfferMetafieldsResponseBodyType = z.infer<
  typeof SyncOfferMetafieldsResponseBodySchema
>;
